// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__kvtgN","noInteraction":"EventWrapper_noInteraction__-PS2Z"};